import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";

const EmployeeListview = (props) => {
  const { addForm, update } = props;

  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");

  // const [allData, setAllData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;

  const { sendRequest: getUser } = useHttp();


  // useEffect(() => {
  //   getUser(
  //     {
  //       url: `/api/employeeDetail/?orgId=${localStorage.getItem("orgId")}`,
  //     },
  //     (myres) => {
  //       if (myres) {
  //         var res=myres.data
  //         const sortedData = res.sort((a, b) => b.emailId - a.emailId);
  //         setData(sortedData);
  //         setAllData(sortedData);
  //       }
  //     }
  //   );
  // }, [getUser]);


  useEffect(() => {
    getUser(
      {
        url: `/api/employeeDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&page=${currentPage}&page_size=${itemsPerPage}&search=${searchText}`,
      },
      (myres) => {
        if (myres) {
          console.log("API RESPONSE", myres);

          setData(myres.data || []);
          setTotalItems(myres.total || 0);
        }
      }
    );
  }, [getUser, currentPage, searchText]);



  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    setSelectedData(data);

    setIsModalOpen(true);
  };

  //   const handleSearch = (e) => {
  //       var filetrtext = e.target.value.trim().toLowerCase();

  //     var filterdata = allData.filter(
  //       (item) =>
  //         item.employeeName?.toLowerCase().includes(filetrtext) ||
  //         item.employeeCode?.toLowerCase().includes(filetrtext) ||
  //         item.designationName?.toLowerCase().includes(filetrtext) ||
  //         item.departmentName?.toLowerCase().includes(filetrtext) ||
  //         item.reportingEmployeeName?.toLowerCase().includes(filetrtext)
  //     );

  //    setData(filterdata); 

  // setCurrentPage(1);
  //   };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };


  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);

        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              organization Employee
            </label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
                props.sId(serviceId || 0);
              }}
            >
              Add Employee
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <table className="table table-bordered text-center table-sm">
                      <thead>
                        <tr>
                          <th>Profile Pic</th>
                          <th>Employee Name</th>
                          <th>Employee Code</th>
                          {/* <th>Contact Number</th>
                          <th>whatsappNo</th> */}
                          <th>Designation</th>
                          <th>Department</th>
                          <th>Email id</th>
                          <th>Reporting Employee</th>
                          <th>Edit</th>
                          <th>View</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data &&
                          data.length > 0 &&
                          data.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  <img
                                    src={
                                      itm.profileurl
                                        ? `${process.env.REACT_APP_FILE_URL}${itm.profileurl}`
                                        : "/user.jpeg"
                                    }
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="User"
                                  />
                                </td>

                                <td>{itm.employeeName || "-"}</td>
                                <td>{itm.employeeCode || "-"}</td>
                                <td>{itm.designationName || "-"}</td>
                                <td>{itm.departmentName || "-"}</td>
                                <td>{itm.emailId || "-"}</td>
                                <td>{itm.reportingEmployeeName || "-"}</td>

                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.sId(serviceId || 0);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>

                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}

                        {data.length === 0 && (
                          <tr>
                            <td colSpan="9">No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      // totalItems={data.length}
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Employee Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6">
                Employee Name: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                Employee Code: {selectedData.employeeCode}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Email Id: {selectedData.emailId}</p>
              <p className="col-md-6">Gender : {selectedData.gender}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Whatsapp Number: {selectedData.whatsappNo}
              </p>
              <p className="col-md-6">
                Contact Number: {selectedData.contactNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Date Of joining: {selectedData.dateofJoining}
              </p>
              <p className="col-md-6">Birth Date: {selectedData.birthDate}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Designation: {selectedData.designationName}
              </p>
              <p className="col-md-6">
                Department: {selectedData.departmentName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Employee Type: {selectedData.employeeType}
              </p>
              <p className="col-md-6">
                Employment Type: {selectedData.employmentType}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Gross Salary: {selectedData.grossSalary}
              </p>
              <p className="col-md-6">Location: {selectedData.warehouseName}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Reporting Employee: {selectedData.reportingEmployeeName}
              </p>
              <p className="col-md-6">
                Work Contact Number: {selectedData.workContactNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Work Email: {selectedData.workEmailId}</p>
              <p className="col-md-6">Id Proof: {selectedData.idProof}</p>
            </div>
            <div className="row">
              <p className="col-md-6">Region Name: {selectedData.regionName}</p>
              <p className="col-md-6">User Name: {selectedData.userName}</p>
            </div>
            <h5 className="card-title">Employee Address Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Address Type</th>
                  <th>Address(landmark)</th>
                  <th>LGA</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.address &&
                  selectedData.address.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.addressType}</td>
                        <td>{itm.landmark}</td>
                        <td>{itm.lga}</td>
                        <td>{itm.city}</td>
                        <td>{itm.state}</td>
                        <td>{itm.zipcode}</td>
                        <td>{itm.country}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <br />
            <h4 className="card-title">Employee Bank Details</h4>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.bankDetail &&
                  selectedData.bankDetail.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>

                        <td>{itm.ifscCode}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>{" "}
          </div>
        )}
      </Modal>
    </>
  );
};

export default EmployeeListview;
